import * as Yup from 'yup'

export const validationSchema = Yup.object({
  translation: Yup.object().shape({
    question: Yup.string().required(),
    answer: Yup.string().required()
  })
})